import _ from 'lodash';
import moment from 'moment';
import cashflowHistory from '../utilities/cashflow-history';

const TITLE_OPTIONS = [
  {
    label: 'יום בבריכה או בים',
    class: 'pool',
    variant: 'male',
  }, {
    label: 'חופשה משפחתית',
    class: 'vacation',
    variant: 'female',
  }, {
    label: 'חתונה של חבר או חברה',
    class: 'wedding',
    variant: 'female',
  }, {
    label: 'יום יקר לאללה ☹️',
    class: 'expensive',
    variant: 'mail',
  }, {
    label: 'בילוי ששווה כל שקל!',
    class: 'worth-it',
    variant: 'mail',
  }, {
    label: 'יום תזרימי במיוחד 😀',
    class: 'cashflowy',
    variant: 'mail',
  },
];

const state = {
  selectableTransactions: [],
  title: '',
};

const getters = {
  titlesOptions: () => TITLE_OPTIONS,
  selectedTransactions: state => _.chain(state.selectableTransactions)
    .filter(t => t.selected)
    .orderBy(['transactionDate', 'businessName'])
    .value(),
};

const actions = {
  async initTransactions({ commit }) {
    const presentedBudgetDates = cashflowHistory.getPresentedBudgetDates();
    const budgets = await cashflowHistory.getBudgets(presentedBudgetDates);
    const transactions = _.chain(budgets)
      .flatMap(budget => budget.envelopes)
      .filter(_envelopesIsVariableOrTracking)
      .flatMap(envelope => envelope.actuals)
      .map(transaction => _.extend({}, transaction, { selected: false, transactionDate: moment(transaction.transactionDate) }))
      .value();
    commit('setSelectableTransactions', transactions);
    commit('setTitle', TITLE_OPTIONS[0].label);
  },
  toggleSelection({ commit }, transactionId) {
    commit('selectTransaction', transactionId);
  },
  setTitle({ commit }, title) {
    commit('setTitle', title);
  },
};

function _envelopesIsVariableOrTracking(envelope) {
  return envelope.type === 'variable' || envelope.type === 'trackingCategory';
}

// mutations
const mutations = {
  setSelectableTransactions(state, transactions) {
    state.selectableTransactions = transactions;
  },
  setTitle(state, title) {
    state.title = title;
  },
  selectTransaction(state, transactionId) {
    const transaction = _.find(state.selectableTransactions, { transactionId });
    transaction.selected = !transaction.selected;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
